<div class="bundle-item-list">
  @for (product of bundle().products; track product) {
    <ui-product-bundle-item
      [arePricesVisible]="arePricesVisible()"
      [bundleType]="bundleType()"
      [bundleItem]="product"
      [isFreeItem]="product.isFree"
    ></ui-product-bundle-item>
  }
</div>
